<template>
  <div class="news">
    <el-row>
      <el-col :span="24">
        <div class="newsContent">
          <ul>
            <li
              v-for="(item,index) in caseList.slice(0,showL)"
              @click="$router.push({path:'/caseDetail',query:{id:item.id,name:name}})"
            >
              <div class="pic">
                <img :src="settings.apiBaseImg + item.image" alt />
              </div>
              <div class="caseTitle">{{item.name}}</div>
              <div class="caseIntro">{{item.describe}}</div>
              <div class="content">
                <p class="contentT">{{item.name}}</p>
                <p class="contentN">{{item.describe}}</p>
              </div>
            </li>
          </ul>
          <div class="more">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-size="pageSize"
            ></el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from "../../assets/js/request.js";
import qs from "qs";
export default {
  data() {
    return {
      activeIndex: 0,
      showL: 6,
      caseList: [],
      id: "",
      currentPage: 1,
      pageSize: 6,
      total: 0,
    };
  },
  created() {
    this.getData(this.id);
  },
  methods: {
    getStyle(index) {
      this.activeIndex = index;
    },
    goMore() {
      if (this.showL < this.caseList.length) {
        this.showL = this.showL + 3;
      } else {
        this.$message("暂无更多设备信息");
      }
    },
    getData(id, name, currentPage, pageSize) {
      this.name = name;
      request
        .post(
          this.settings.apiBaseUrl + "/api/index/case_list",
          qs.stringify({
            case_type_id: id,
            page: currentPage,
            pagesize: pageSize,
          }),
          {
            headers: {},
          }
        )
        .then((res) => {
          if (res.code == 1) {
            this.caseList = res.data.rows;
            this.total = res.data.total;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    handleSizeChange(val) {
      this.pageSize = val; //将每页显示的条数 = 改变的值
      this.getData(this.id, name, this.currentPage, this.pageSize);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData(this.id, name, this.currentPage, this.pageSize);
    },
  },
};
</script>

<style scoped="scoped">
.news {
  width: 100%;
  height: auto;
}

.newsContent {
  width: 100%;
  height: auto;
  margin-top: 80px;
}

.newsContent ul li {
  width: 30%;
  height: 450px;
  box-sizing: border-box;
  display: inline-block;
  margin-right: 3%;
  cursor: pointer;
  transition: all 0.5s ease;
  position: relative;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  margin-bottom: 87px;
  overflow: hidden;
  /* animation: changeBiger 4s linear forwards;
		animation-delay: 5s;
		-webkit-animation-delay: 5s; */
}

.newsContent ul li:hover .content {
  transition: all 0.5s ease;
  display: block;
}

.newsContent ul li .pic {
  width: 100%;
  height: 70%;
}

.pic img {
  width: 100%;
  height: 100%;
}

.caseTitle {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  line-height: 25px;
  text-align: center;
  margin-top: 30px;
  padding: 0 40px;
}

.caseIntro {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #808080;
  line-height: 21px;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  width: 90%;
  margin: 30px auto;
}

.content {
  display: none;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 50%;
  margin: 0 auto;
  background-color: #216bd1;
  background-size: 100% 100%;
  padding: 40px 40px;
  box-sizing: border-box;
  transition: all 0.5s ease;
}

.content .contentT {
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 18px;
}

.content .contentN {
  margin-top: 30px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 26px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.more {
  width: 100%;
  height: auto;
  text-align: center;
  margin-top: 80px;
  margin-bottom: 150px;
}

.more button {
  width: 205px;
  height: 50px;
  background: #ffffff;
  border: 1px solid #216bd1;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #216bd1;
  line-height: 19px;
}
</style>



// WEBPACK FOOTER //
// src/components/case/case.vue